import Reveal from '@/components/base/Reveal';
import CtaLink from '@/pages/home/components/CtaLink';

export default function FinalCta() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[560px] h-[560px] rounded-full bg-primary-500/10 blur-[130px]" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 md:px-6 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Your Business Could Be Next
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950">
            Ready to Find the Growth Opportunities in Your Marketing?
          </h2>
          <p className="mt-5 text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            If you already have a strong business but your marketing feels
            inconsistent, difficult to measure, or harder to scale than it
            should be,Josh can help identify what needs to change.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <CtaLink>Apply to Work With Me</CtaLink>
            <CtaLink variant="secondary">See If We&rsquo;re a Fit</CtaLink>
          </div>

          <p className="mt-8 text-xs text-foreground-600 font-label font-medium">
            Done For You Marketing &bull; Done With You Consulting
          </p>
        </Reveal>
      </div>
    </section>
  );
}
